<template>
  <transition name="slide-fade">
    <div class="panel">
      <div id="firebaseui-auth-container"></div>
    </div>
  </transition>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import firebaseui from "firebaseui";
import "../../node_modules/firebaseui/dist/firebaseui.css";
import { mapMutations } from "vuex";

export default {
  name: "auth",
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$router.push("/");
      }
    });
  },
  methods: {
    ...mapMutations([
      "changePageTitle",
      "changePageIntroText",
      "modifyLoggedIn",
    ]),
  },
  mounted() {
    const uiConfig = {
      signInSuccessUrl: "/",
      signInOptions: [
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      ],
      signInFlow: "popup",
    };

    // Set logged in to false.
    this.modifyLoggedIn(false);

    let ui = firebaseui.auth.AuthUI.getInstance();

    // We only want to create a new auth ui instance if it doesn't already exist.
    // Not doing this can cause errors about it already being created after logging out.
    if (!ui) ui = new firebaseui.auth.AuthUI(firebase.auth());

    ui.start("#firebaseui-auth-container", uiConfig);

    // Set the page title.
    this.changePageTitle("Login");

    // Set page text.
    this.changePageIntroText();
  },
};
</script>

<style scoped>
h1 {
  text-align: center;
}

.panel {
  padding: 2rem;
}
</style>
